import * as K from './ClientsConstants';
import Fuse from 'fuse.js';
import feathers from '../../../feathers';

import floopback from '../../../lib/floopback';
var clients = new floopback('clients');
export function stateInit(value) {
  return {
    type: K.STATEINIT,
  };
}
export function find(params) {
  return async (dispatch, getState) => {
    var _this = this;
    let clientsResults = await feathers.service('clients').find({
      query: params,
    });
    dispatch({
      type: K.FIND + '_FULFILLED',
      payload: clientsResults.data,
    });

    _this.searchTable(getState().Clients.search);
  };
}

export function findById(id) {
  return (dispatch, getState) => {
    dispatch({
      type: K.FIND_BY_ID,
      payload: clients.findById(id),
    });
  };
}

export function create(formData) {
  return (dispatch, getState) => {
    return new Promise(function (resolve, reject) {
      dispatch({ type: K.CREATE + '_PENDING', payload: formData });
      clients
        .create(formData)
        .then(function (data) {
          dispatch({ type: K.CREATE + '_FULFILLED', payload: data });
          resolve(data);
        })
        .catch(function (error) {
          dispatch({ type: K.CREATE + '_REJECTED', payload: error });
          reject(error);
        });
    });
  };
}

export function update(id, formData) {
  return (dispatch, getState) => {
    return new Promise(function (resolve, reject) {
      dispatch({ type: K.UPDATE + '_PENDING', payload: formData });
      clients
        .update(id, formData)
        .then(function (data) {
          dispatch({ type: K.UPDATE + '_FULFILLED', payload: data });
          resolve(data);
        })
        .catch(function (error) {
          dispatch({ type: K.UPDATE + '_REJECTED', payload: error });
          reject(error);
        });
    });
  };
}

export function remove(id) {
  return (dispatch, getState) => {
    return new Promise(function (resolve, reject) {
      dispatch({ type: K.DELETE + '_PENDING' });
      clients
        .delete(id)
        .then(function (data) {
          dispatch({ type: K.DELETE + '_FULFILLED', payload: data });
          resolve(data);
        })
        .catch(function (error) {
          dispatch({ type: K.DELETE + '_REJECTED', payload: error });
          reject(error);
        });
    });
  };
}

export function changeTable(feature, value) {
  return (dispatch, getState) => {
    dispatch({
      type: K.CHANGE_TABLE,
      payload: {
        feature: feature,
        value: value,
      },
    });
  };
}

export function searchTable(search) {
  return (dispatch, getState) => {
    var options = {
      threshold: 0.4,
      location: 0,
      distance: 100,
      maxPatternLength: 32,
      minMatchCharLength: 1,
      keys: [
        'id',
        'nombre',
        'firstName',
        'lastName',
        'user.lastName',
        'email',
        'phone',
      ],
    };

    var fuse = new Fuse(getState().Clients.data, options);
    let result = fuse.search(search);

    dispatch({
      type: K.SEARCH_TABLE,
      payload: {
        search: search,
        searchData: result,
      },
    });
  };
}



// WEBPACK FOOTER //
// ./src/views/Clients/redux/ClientsActions.jsx